exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center-icon {\n  align-self: center;\n}\n.success {\n  background-color: rgba(0, 152, 35, 0.41);\n  border-radius: 5px\n}\n.break-full {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n}\n", ""]);

// exports
